// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__36lNp","row":"Node_row__1wCiL","label":"Node_label__2vtRk","footer":"Node_footer__3bq07"};